import React, { useEffect } from "react";
import flip_icon from "../../../../../../../../assets/images/flip_icon.svg";
import CustomInput from "../../../../../../CommonComponents/CustomForm/CustomInputField";
const RotateSection = ({ tool, setTool, handleSubmitBtnState, totalPages, handleChange, errorState }) => {
  const handleRotation = (value, type) => {
    if (type === "rotate") {
      setTool({
        ...tool,
        rotate: value ?? tool?.rotate,
      });
    } else {
      setTool({
        ...tool,
        flip: tool?.flip === 1 ? -1 : 1,
      });
      
    }
    handleSubmitBtnState()
  };

  useEffect(() => {
    if (tool.rotate > 360) {
      handleRotation(0, "rotate")
    }
  }, [tool.rotate])

  return (
    <>
      <div className="transparency-section-flip row">
        <div className="col-5 d-flex rotate-flip-icon">
          <div className="d-flex align-items-center">
            <p className="img-lab-clr mb-0 me-2">Rotate:</p>
            <div className="d-flex align-items-center">
              <CustomInput
                placeholder={""}
                value={tool?.rotate}
                name={"rotate"}
                onChange={(e) => handleRotation(e.target.value, "rotate")}
                required={false}
                type={"number"}
                max={360}
                onFocus={(e) => e.target.select()}
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                style={{ height: '38px', width: '60px', padding: '4px 12px' }}
              />
              <span className="fs-3 ms-2">&deg;</span>
            </div>
          </div>
          <div className="d-flex align-items-center ms-3">
            <p className="img-lab-clr mb-0 me-2">Flip:</p>
            <img
              src={flip_icon}
              alt="flip icon"
              height="20px"
              onClick={() => handleRotation(-1, "flip")}
              style={{ cursor: 'pointer' }}
            />
          </div>
        </div>
        <div className="col-7 text-end">
          <div className="show-on d-flex align-items-center justify-content-end">
            <p className="img-lab-clr mb-0 me-2">SHOW ON PAGE:</p>
            <div className="d-flex align-items-center">
              <input
                type="number"
                name="page"
                min={1}
                value={tool?.page}
                onFocus={(e) => e.target.select()}
                onChange={handleChange}
                style={{ height: '38px' }}
              />
              <span className="ms-2">/ {totalPages ?? 1}</span>
            </div>
          </div>
          {((tool?.page == tool?.value?.page_link) || (tool?.page == tool?.jump_to_page)) && (
            <p className="text-danger text-end mt-2 mb-0">{errorState?.pageErr}</p>
          )}
        </div>
      </div>
    </>
  );
};
export default RotateSection;